// React Lazily
import { lazily } from 'react-lazily'

// Interface
import { IRoute } from 'routes/route.interface'

// Constant
import { MASTER_URL, MASTER_MODULE } from 'constant/url.constant'
import { LAYOUT } from 'constant/layout.constant'

// UI
const { DocumentProofIndex } = lazily(() => import('pages/back-office/master/document-proof'))

const documentProofRoutes: IRoute[] = [
  {
    path: MASTER_URL.DOCUMENT_PROOF,
    component: DocumentProofIndex,
    layout: LAYOUT.BACK_OFFICE,
    exact: true,
    meta: {
      module: MASTER_MODULE,
      requireAuth: false,
      attrs: {
        label: 'masterDocumentProof.documentProof',
        accessCodes: [998],
      },
    },
  },
]

export { documentProofRoutes }
